export const ACCOUNT_CREATED = "Account created";
export const EXCHANGE_FILTER_SORT = "Exchange filter/sort";
export const EXCHANGE_RUNTIME_ERROR = "Exchange runtime error"; // calling posthog.capture with this event name will trigger a monitor alert
export const EXCHANGE_SEARCH = "Exchange search";
